import HeroForm from './HeroForm';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/5c2005863756bb53067683b63548dd23.jpg"
          alt="Interior Design Workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="inline-flex items-center bg-[#C5A572]/90 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
              <div className="w-2 h-2 bg-white rounded-full mr-2"></div>
              <span className="text-sm font-medium text-white">Trade Solutions For Interior Designers</span>
            </div>

            <h1 className="mb-6">
              <div className="text-6xl md:text-7xl font-bold tracking-tight mb-2">
                DESIGN ASSIST
              </div>
              <div className="text-4xl md:text-5xl font-serif italic mb-2">
                Your Procurement Partner
              </div>
              <div className="text-2xl md:text-3xl font-medium text-gray-200">
                From Factory to Fulfillment
              </div>
            </h1>

            <p className="text-lg text-gray-200 mb-10 max-w-xl leading-relaxed">
              Access exclusive trade pricing and streamline your procurement process. We handle the logistics so you can focus on creating beautiful spaces.
            </p>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollToSection('services')}
                className="group bg-[#2B2B2B] text-white px-8 py-4 rounded-full text-sm font-medium hover:bg-[#3B3B3B] transition-all cursor-pointer whitespace-nowrap flex items-center"
              >
                <span className="w-8 h-8 bg-[#C5A572] rounded-full flex items-center justify-center mr-3">
                  <i className="ri-arrow-right-line text-white"></i>
                </span>
                EXPLORE SERVICES
              </button>
            </div>
          </div>

          <div className="hidden md:flex justify-end">
            <HeroForm />
          </div>
        </div>
      </div>
    </section>
  );
}
